
import LandingPage from "../views/marketing-pages/landing/index";


// ==============|| MAIN ROUTING ||============ //
async function checkIfUserIsLoggedIn() {
  const token = localStorage.getItem('token');
  return token !== null;
}

const MainRoutes = {
  path: "/",
  element: <><LandingPage /></>,
  loader: async () => {
    const isLoggedIn = await checkIfUserIsLoggedIn();
    return isLoggedIn ? { pathname: "/dashboard" } : null;
  },
};



export default MainRoutes;